import { useNavigate } from 'react-router-dom';
import { Anchor, TrendingUp, Assessment, AutoAwesome } from '@mui/icons-material';

const LeagueStatsPage = () => {
    const navigate = useNavigate();

    const statsOptions = [
        {
            title: "Hardstuck Analyse",
            description: "Se spillere der har været fanget i samme division i flere sæsoner",
            route: "/leaguestats/hardstuck",
            icon: <Anchor className="text-secondary" style={{ fontSize: 48 }} />,
            color: "border-secondary"
        },
        {
            title: "Division Klatrere",
            description: "Se de største spring op og ned mellem sæsoner",
            route: "/leaguestats/climbers",
            icon: <TrendingUp className="text-success" style={{ fontSize: 48 }} />,
            color: "border-success"
        },
        {
            title: "Talenter",
            description: "Find de bedste unge spillere på tværs af alle divisioner",
            route: "/leaguestats/talents",
            icon: <AutoAwesome className="text-warning" style={{ fontSize: 48 }} />,
            color: "border-warning"
        }
    ];

    return (
        <div className="container mt-4">
            <div className="row mb-4">
                <div className="col">
                    <h1 className="text-white mb-3 d-flex align-items-center">
                        <Assessment className="me-2" /> Liga Statistik Analyse
                    </h1>
                    <p className="text-white-50">
                        Dybdegående analyse af spilleres historik og progression gennem sæsonerne. Perfekt til at identificere trends og mønstre.
                    </p>
                </div>
            </div>

            <div className="row g-4">
                {statsOptions.map((option, index) => (
                    <div key={index} className="col-md-4">
                        <div 
                            className={`card bg-dark text-white h-100 ${option.color} border-2 stats-card`}
                            style={{ cursor: 'pointer', transition: 'transform 0.2s' }}
                            onClick={() => navigate(option.route)}
                            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
                            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                        >
                            <div className="card-body text-center d-flex flex-column">
                                <div className="mb-3">
                                    {option.icon}
                                </div>
                                <h5 className="card-title">{option.title}</h5>
                                <p className="card-text text-white-50 flex-grow-1">
                                    {option.description}
                                </p>
                                <button className="btn btn-outline-light btn-sm mt-3">
                                    Se Analyse →
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="row mt-5">
                <div className="col">
                    <div className="alert alert-info">
                        <h5 className="alert-heading d-flex align-items-center">
                            <Assessment className="me-2" /> Om Liga Statistik
                        </h5>
                        <hr />
                        <p className="mb-2">
                            Disse analyser giver indsigt i spillernes langsigtede præstationer og udvikling i PowerLigaen.
                        </p>
                        <ul className="mb-0">
                            <li><strong>Hardstuck:</strong> Find spillere der har været i samme division i flere sæsoner</li>
                            <li><strong>Klatrere:</strong> Se hvem der har gjort de største spring mellem sæsoner</li>
                            <li><strong>Talenter:</strong> De bedste unge spillere, sorteret efter division og rating</li>
                        </ul>
                        <p className="mb-0 mt-3">
                            <small>Perfekt til at skabe indhold om spillerhistorik og divisionsudvikling!</small>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LeagueStatsPage;